var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25332 4.82376C7.58223 5.10859 7.58223 5.61882 7.25332 5.90366L4.77299 8.05169C4.31038 8.45232 3.59109 8.12371 3.59109 7.51174L3.59109 3.21567C3.59109 2.60371 4.31038 2.2751 4.77298 2.67572L7.25332 4.82376Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRightIcon);
export default __webpack_public_path__ + "static/media/white-right-icon.2e745e411805f56b298754f3d8a075a0.svg";
export { ForwardRef as ReactComponent };